"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { getDefaultQueryRetry } from "@/components/react-query-wrapper/utils/query-utils";
import type { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
interface UseFavouriteWavesOfIdentityProps {
  readonly identityKey: string | null;
  readonly limit?: number | undefined;
  readonly enabled?: boolean | undefined;
}
export function useFavouriteWavesOfIdentity(t0) {
  const $ = _c(21);
  const {
    identityKey,
    limit: t1,
    enabled: t2
  } = t0;
  const limit = t1 === undefined ? 3 : t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  if ($[0] !== identityKey) {
    t3 = identityKey?.trim() ?? null;
    $[0] = identityKey;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const normalizedIdentityKey = t3;
  const activeIdentityKey = normalizedIdentityKey ?? "";
  let t4;
  if ($[2] !== limit || $[3] !== normalizedIdentityKey) {
    t4 = [QueryKey.IDENTITY_FAVOURITE_WAVES, {
      identity_key: normalizedIdentityKey,
      limit
    }];
    $[2] = limit;
    $[3] = normalizedIdentityKey;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== activeIdentityKey || $[6] !== limit) {
    t5 = async () => await commonApiFetch({
      endpoint: `waves-overview/favourites-of-identity/${encodeURIComponent(activeIdentityKey)}`,
      params: {
        limit: `${limit}`,
        offset: "0"
      }
    });
    $[5] = activeIdentityKey;
    $[6] = limit;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = enabled && activeIdentityKey.length > 0;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = getDefaultQueryRetry();
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t8 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6,
      ...t7
    };
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const query = useQuery(t8);
  let t9;
  if ($[13] !== query.data) {
    t9 = query.data ?? [];
    $[13] = query.data;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== query.error || $[16] !== query.isFetching || $[17] !== query.refetch || $[18] !== query.status || $[19] !== t9) {
    t10 = {
      waves: t9,
      status: query.status,
      error: query.error,
      refetch: query.refetch,
      isFetching: query.isFetching
    };
    $[15] = query.error;
    $[16] = query.isFetching;
    $[17] = query.refetch;
    $[18] = query.status;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}